import React from 'react';
import PropTypes from 'prop-types';
import { useLocale } from 'next-intl';
import StyledDateLine from './date-line.style';
import Headline from '../../../../../../atoms/headline/headline';

const SelectionDateLine = ({ date }) => {
  const locale = useLocale();
  return (
    <StyledDateLine>
      <div className="dateLine__date">
        <span>{date?.toLocaleDateString(locale, { day: '2-digit' })}</span>
      </div>
      <div className="dateLine__line">
        <Headline tag="span" subline>
          {date?.toLocaleDateString(locale, {
            day: 'numeric',
            weekday: 'long',
            month: 'long'
          })}
        </Headline>
      </div>
    </StyledDateLine>
  );
};

SelectionDateLine.propTypes = {
  date: PropTypes.shape().isRequired
};

export default SelectionDateLine;
